import "./Footer.css";

function Footer() {
    return (
        <footer className="footer">
            <p>
                REV Dashboard • School of Engineering • The University of Western Australia
            </p>

            <p>
                © {new Date().getFullYear()} REV Project
            </p>

            <p>
                Designed By Jeremy Robertson
            </p>
        </footer>
    );
}

export default Footer;